import { render, staticRenderFns } from "./AvatarSelector.vue?vue&type=template&id=5cb7d2be&scoped=true&"
import script from "./AvatarSelector.vue?vue&type=script&lang=js&"
export * from "./AvatarSelector.vue?vue&type=script&lang=js&"
import style0 from "./AvatarSelector.vue?vue&type=style&index=0&id=5cb7d2be&prod&lang=scss&"
import style1 from "./AvatarSelector.vue?vue&type=style&index=1&id=5cb7d2be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb7d2be",
  null
  
)

export default component.exports